export function onSamePageHashLinkClick(root, callback) {
  if (!root) return () => {};

  const handler = (e) => {
    const link = e.target?.closest?.('a[href]');
    if (!link || !root.contains(link)) return;

    let url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch {
      return;
    }

    if (!url.hash || url.hash === '#') return;

    const normalizePath = (p) => p.replace(/\/+$/, '') || '/';
    const sameDocument =
      url.origin === window.location.origin &&
      normalizePath(url.pathname) === normalizePath(window.location.pathname);

    if (!sameDocument) return;

    // Let the consumer decide what to do (do not prevent default here).
    callback?.(e, link, url);
  };

  root.addEventListener('click', handler);
  // Return an unsubscribe function
  return () => root.removeEventListener('click', handler);
}
